import { useContext } from 'react';
import {
  AppContext,
  AuthContext,
  RoutesContext,
  BookingContext,
  CacheContext,
  LanguageContext,
} from 'contexts';

// Same hook as the TO: the provider lives in @koob/notifications now.
export { useNotifications } from '@koob/notifications';

export const useApp = () => {
  const context = useContext(AppContext);

  if (context === undefined) {
    throw new Error(`useApp must be used within an AppProvider`);
  }

  return context;
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error(`useAuth must be used within an AuthProvider`);
  }

  return context;
};

export const useRoutes = () => {
  const context = useContext(RoutesContext);

  if (context === undefined) {
    throw new Error(`useRoutes must be used within an RoutesProvider`);
  }

  return context;
};

export const useBooking = () => {
  const context = useContext(BookingContext);

  if (context === undefined) {
    throw new Error(`useBooking must be used within an BookingContext`);
  }

  return context;
};

export const useCache = () => {
  const context = useContext(CacheContext);

  if (context === undefined) {
    throw new Error(`useCache must be used within a CacheContext`);
  }

  return context;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);

  if (context === undefined) {
    throw new Error(`useLanguage must be used within an LanguageContext`);
  }

  return context;
};
